<form class="popupForm" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Trainer pricing
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke flex-justify-start" style="display: flex !important;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <div *ngIf="state==='edit'">
        <div style="margin: 20px 0px; font-size: 0.8em;">
          This form is for trainer's services configuration.
        </div>
        <div style="margin: 20px 0px; font-size: 0.8em;" *ngIf="!profilePayloadParsed['skip_on_public_trainers_list']">
          ✅ This trainer is public!
        </div>
        <div style="margin: 20px 0px; font-size: 0.8em;" *ngIf="profilePayloadParsed['skip_on_public_trainers_list']">
          ⚠ This trainer is not public yet.
        </div>
        <ng-container *ngFor="let packageItem of this.packages; let idx = index">
          <fieldset>
            <legend style="font-size: 0.85em; font-weight: 500;">{{packageItem['name']}}</legend>
            <div>
              <div style="margin: 14px 0px">
                <mat-slide-toggle formControlName="{{'packageEnabled_'+idx}}">
                  {{'package_enabled'|GetLabelPipe}}
                </mat-slide-toggle>
              </div>
            </div>
            <div class="flex-row-center flex-justify-start">
              <mat-form-field appearance="outline" color="accent" style="width: 100px">
                <mat-label>{{'package_price' | GetLabelPipe}}</mat-label>
                <input matInput type="text" formControlName="{{'packagePrice_'+idx}}">
              </mat-form-field>
              <div>
                &nbsp;&nbsp;&nbsp;Default price <b>{{packageItem['price']}} {{packageItem['currency']}}</b>
              </div>
            </div>
            <div>
              <mat-form-field appearance="outline" color="accent" style="width: 100px">
                <mat-label>{{'package_guest_price' | GetLabelPipe}}</mat-label>
                <input matInput type="text" formControlName="{{'packageGuestPrice_'+idx}}">
              </mat-form-field>
              &nbsp;&nbsp;
              <mat-form-field appearance="outline" color="accent" style="width: 100px">
                <mat-label>{{'package_discount_price' | GetLabelPipe}}</mat-label>
                <input matInput type="text" formControlName="{{'packageDiscountPrice_'+idx}}">
              </mat-form-field>
            </div>
          </fieldset>
          <br>
        </ng-container>
      </div>
      <br>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'cancel'|GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent"
              (click)="handleSubmit()" [disabled]="state === 'loading'">
        {{'save'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
